import React, { PureComponent as Component } from 'react';
import { CardBody, Collapse } from 'reactstrap';
import propTypes from 'prop-types';

import SearchForm from './SearchForm';
import FilterForm from './FilterForm';
import SortForm from './SortForm';

export default class Filters extends Component {
  render(){
    return(
      <Collapse isOpen={this.props.isOpen}>
        <CardBody className="filter-container__card-body">
          <SearchForm
            keyword = {this.props.keyword}
            onInputChange = {this.props.onHandleChange}
            onSubmit = {this.props.onHandleSearch}
          />
          <FilterForm
            active = {this.props.active}
            duration = {this.props.duration}
            onCheckedChange = {this.props.onHandleChange}
            onSubmit = {this.props.onHandleSearch}
          />
          <hr/>
          <SortForm
            per_page={this.props.per_page}
            sort_by={this.props.sort_by}
            status={this.props.status}
            onInputChange={this.props.onHandleChangeAndSubmit}
          />
        </CardBody>
      </Collapse>
    )
  }
}

Filters.propTypes= {
  keyword: propTypes.string,
  per_page: propTypes.oneOfType([propTypes.number, propTypes.string]),
  sort_by: propTypes.string,
  active: propTypes.string,
  duration: propTypes.string,
  isOpen: propTypes.bool.isRequired,
  onHandleChange: propTypes.func,
  onHandleChangeAndSubmit: propTypes.func
}

Filters.defaultProps= {
  keyword: '',
  per_page: 15,
  sort_by: '',
  active: '',
  duration: ''
}